/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useState } from 'react';
import './App.scss';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ContextProvider from './Context/Context';
import Home from './Pages/Home/Home';
import ProductList from './Pages/ProductList/ProductList';
import Address from './Pages/Address/Address';
import PaymentChoice from './Pages/PaymentChoice/PaymentChoice';
import Header from './Components/Header/Header';
import Authentication from './Components/Authentication/Authentication';
import Footer from './Components/Footer/Footer';
import Page404 from './Pages/404/Page404';
import CartPage from './Pages/CartPage/CartPage';
import CartProvider from './Context/CartContext/CartContext';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import AddAddress from './Pages/AddAddress/AddAddress';
import ThankYou from './Pages/ThankYou/ThankYou';
import PastOrders from './Pages/PastOrders/PastOrders';
import ProductDetails from './Pages/ProductDetails/ProductDetails';
import 'react-toastify/dist/ReactToastify.css';

const App: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerProps = { isOpen, setIsOpen };
  return (
    <>
      <ToastContainer />
      <CartProvider>
        <ContextProvider>
          <div className="App">
            <Router>
              <ScrollToTop />
              <Header {...headerProps} />
              {isOpen}
              <div className="container" onClick={() => setIsOpen(false)} aria-hidden>
                <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/product-list/:category" component={ProductList} />
                  <Route path="/product-details/:id" component={ProductDetails} />
                  <Route path="/address" component={Address} />
                  <Route path="/auth" component={Authentication} />
                  <Route path="/cart" component={CartPage} />
                  <Route path="/checkout" component={PaymentChoice} />
                  <Route path="/add-address" component={AddAddress} />
                  <Route path="/thank-you" component={ThankYou} />
                  <Route path="/orders" component={PastOrders} />
                  <Route path="*" component={Page404} />
                </Switch>
              </div>
              <Footer />
            </Router>
          </div>
        </ContextProvider>
      </CartProvider>
    </>
  );
};
export default App;
